/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { createAction } from ".";
import { User } from "../../models/User.model";
import { Auth } from "../../types/RootState";

export const AUTH_SIGN_OUT_ACTION = "auth.signOut";
export const AUTH_SIGN_IN_ACTION = "auth.signIn";
export const AUTH_SIGN_UP_ACTION = "auth.signUp";
export const AUTH_FORGOT_PASSWORD_ACTION = "auth.forgotPassword";
export const AUTH_CHANGE_PASSWORD_ACTION = "auth.changePassword";
export const AUTH_SET_TOKEN_ACTION = "auth.setToken";
export const AUTH_SET_ACTION = "auth.set";
export const AUTH_SU_ACTION = "auth.su";
export const AUTH_END_SU_ACTION = "auth.endSu";

export const signIn = createAction<{ email: string; password: string }>(AUTH_SIGN_IN_ACTION);
export const signOut = createAction<{}>(AUTH_SIGN_OUT_ACTION);
export const signUp = createAction<{ email: string; password: string }>(AUTH_SIGN_UP_ACTION);
export const forgotPassword = createAction<{ email: string }>(AUTH_FORGOT_PASSWORD_ACTION);
export const setToken = createAction<string>(AUTH_SET_TOKEN_ACTION);
export const setPartiallyAuth = createAction<Partial<Auth>>(AUTH_SET_ACTION);
export const su = createAction<User>(AUTH_SU_ACTION);
export const endSu = createAction(AUTH_END_SU_ACTION);
export const changePassword = createAction<{ currentPassword: string; newPassword: string }>(
    AUTH_CHANGE_PASSWORD_ACTION
);



// WEBPACK FOOTER //
// ./src/store/actions/auth.actions.ts